export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_OUT = 'SIGN_OUT'
export const PROMPT_SIGN_IN = 'PROMPT_SIGN_IN'
export const DECLINE_SIGN_IN = 'DECLINE_SIGN_IN'
export const ADD_PERMISSON = 'ADD_PERMISSON'
